import { Contract } from '../contract';
export class Contractdate {
    constructor(
        public id?: number,
        public realDate?: any,
        public originalDate?: any,
        public evasiveDate?: any,
        public gguid?: string,
        public contract?: Contract,
    ) {
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/contractdate/contractdate.model.ts